// extracted by mini-css-extract-plugin
export default {"colorTextLabel":"E3-z","colorTextValue":"F3-z","swatches":"G3-z","collapseLink":"H3-z","isCollapsed":"I3-z","dropdown":"J3-z","disabled":"K3-z"};